import { Serializable } from 'types/interfaces';

interface ChartDataApiI {
  t: number;
  a: number;
  e: number;
  g: number;
  r: number;
  gd?: boolean;
}

export interface ChartDataI {
  x: number;
  y: number;
}

interface TeledectionApiI {
  detecciones: Array<ChartDataApiI>;
  generacionDisponible?: boolean;
  acumulados: {
    generacion: number;
    excedente: number;
    autoconsumo: number;
    red: number;
  };
}

export default class TeledectionData implements Serializable<TeledectionData> {
  generationData: Array<ChartDataI>;

  generationDataSegments: Array<Array<ChartDataI>>;

  selfConsumptionData: Array<ChartDataI>;

  shirnkData: Array<ChartDataI>;

  networkonData: Array<ChartDataI>;

  generationAvailable: boolean;

  hasHistoricalGenerationGap: boolean;

  totals: {
    selfconsumption: number;
    shrink: number;
    generation: number;
    network: number;
  };

  deserialize(input: TeledectionApiI): TeledectionData {
    if (!input) {
      return this;
    }

    this.generationDataSegments = [];
    let generationDataSegment: Array<ChartDataI> = [];

    input.detecciones.forEach((detection): void => {
      if (detection.gd === false) {
        if (generationDataSegment.length > 0) {
          this.generationDataSegments.push(generationDataSegment);
          generationDataSegment = [];
        }
        return;
      }

      generationDataSegment.push({
        x: detection.t,
        y: detection.g,
      });
    });
    if (generationDataSegment.length > 0) {
      this.generationDataSegments.push(generationDataSegment);
    }
    this.generationData = this.generationDataSegments.reduce(
      (generationData, segment): Array<ChartDataI> => generationData.concat(segment),
      [],
    );
    const hasGenerationAvailabilityByPeriod = input.detecciones.some(
      (detection): boolean => detection.gd !== undefined,
    );
    this.selfConsumptionData = input.detecciones.map(
      (detection): ChartDataI => ({
        x: detection.t,
        y: detection.gd === false ? 0 : detection.a,
      }),
    );
    this.shirnkData = input.detecciones.map(
      (detection): ChartDataI => ({
        x: detection.t,
        y: -detection.e,
      }),
    );
    this.networkonData = input.detecciones.map(
      (detection): ChartDataI => ({
        x: detection.t,
        y: detection.r,
      }),
    );
    const hasGenerationGap = input.detecciones.some(
      (detection, index): boolean =>
        detection.gd === false &&
        input.detecciones.slice(0, index).some((previous): boolean => previous.gd === true) &&
        input.detecciones.slice(index + 1).some((next): boolean => next.gd === true),
    );
    this.generationAvailable = input.generacionDisponible !== false;
    this.hasHistoricalGenerationGap = hasGenerationGap;
    this.totals = {
      selfconsumption: hasGenerationAvailabilityByPeriod
        ? input.detecciones.reduce(
            (total, detection): number => total + (detection.gd === false ? 0 : detection.a),
            0,
          )
        : input.acumulados.autoconsumo || 0,
      shrink: input.acumulados.excedente || 0,
      generation: input.acumulados.generacion || 0,
      network: input.acumulados.red || 0,
    };

    return this;
  }
}
